import { Injectable } from '@angular/core';
import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
import { environment } from 'src/environments/environment';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor() { }

  generatePdf(data: PdfData) {
    const headers = [];
    const widths = [];

    data.PdfHeaders.forEach((h) => {
      headers.push({
        text: h,
        bold: true,
        fontSize: 12
      });
      widths.push('auto');
    });

    const content = [];
    content.push(headers);

    data.PdfRows.forEach((r) => {
      const rows = [];
      r.forEach((i) => {
        rows.push({
          text: i,
          bold: false,
          fontSize: 10
        });
      });
      content.push(rows);
    });

    const table = [{
        text: data.PdfTitle,
        style: {
          fontSize: 14,
          bold: true
        }
      },
      {
      layout: 'headerLineOnly',
      table: {
        dontBreakRows: true,
        headerRows: 1,
        widths: widths,
        body: content,
        layout: 'headerLineOnly'
      }
    }];

    const documentDefinition = {
      info: {
        title: data.PdfTitle,
        subject: data.PdfTitle,
        keywords: data.PdfTitle.split(' ').join(','),
        author: 'Bankei',
        creator: 'Bankei',
        producer: 'Bankei',
        creationDate: new Date()
      },
      content: table
    };

    return pdfMake.createPdf(documentDefinition);
  }

  generatePdfReport(title: string, data: PdfData, filter: string, queryDate: string, landscape: boolean = false) {
    
    const style = {
      filter:{
        margin:[0,10],
        fontSize: 9
      },
      title: {
        fontSize:14,
        bold:true,
        margin:[0,20,0,0]
      },
      tableHeader: {
        fontSize: 9,
        bold: true
      },
      tableBody: {
        unbreakable: true,
        fontSize: 9
      },
      footerPage:{
        unbreakable: true,
        fontSize: 9,
        margin:[20,10],
        alignment: 'right'
      }
    }

    const headers = [];
    const widths = [];

    data.PdfHeaders.forEach((h) => {
      if(h == 'Valor') {
        headers.push({
          text: h,
          style: 'tableHeader',
          colSpan: 2
        });
        widths.push(12);
      } else {
        headers.push({
          text: h,
          style: 'tableHeader'
        });
        widths.push('auto');
      }
    });

    const content = [];
    content.push(headers);

    data.PdfRows.forEach((r) => {
      const rows = [];
      r.forEach((i) => {
        i = i ? i+'' : '-'
        if(i?.slice(0,2) == 'R$' && i.length > 2){
          rows.push({
            text: i.replace('R$ ',''),
            style: 'tableBody',
            alignment: 'right'
          });
        }
        else {
          rows.push({
            text: i.length>25 ? this.breakText(i) : i,
            style: 'tableBody'
          });
        }
        
      });
      content.push(rows);
    });

    const table = [
      {
        text:[
          title,
          {text: queryDate ? '\nData da consulta: ' + queryDate : null, fontSize: 9, bold: false},
        ],
        style:'title'
      },
      {
        text: filter,
        style: 'filter'
      },
      {
      table: {
        dontBreakRows: true,
        headerRows: 1,
        widths: widths,
        body: content
      },
      layout: {
        hLineWidth: function (i, node) { return  1; },
        vLineWidth: function (i, node) {
          return (headers.find(x => x.text == 'Valor') && (i === headers.map(function(e) { return e.text; }).indexOf('Valor')+1)) ? 0 : 1;
        },
        
        paddingLeft: function(i, node) { return 5; },
        paddingRight: function(i, node) { return 5; },
        
        hLineColor: function (i, node) { return '#dedede'; },
        vLineColor: function (i, node) { return '#dedede'; },
        
        paddingTop: function(i, node) { return 2; },
        paddingBottom: function(i, node) { return 2; },
        
        fillColor: function (rowIndex, node, columnIndex) {
          return (rowIndex % 2 === 0) ? null : '#f2f2f2';
        }
			}
    }];

    let documentDefinition = {};
    
    documentDefinition = {
      header: function(currentPage, pageCount, pageSize) {
        if (currentPage == 1) {
          return [
            {
              image:"data:image/png;base64,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",
              fit:[100,50],
              margin:[0,20],
              alignment:"center"
            }
          ]
        }
      },
      footer: function(currentPage, pageCount) { 
        return { 
          text: 'Página ' + currentPage.toString() + ' de ' + pageCount,
          style: 'footerPage'
        }; 
      },
      info: {
        title: data.PdfTitle,
        subject: data.PdfTitle,
        keywords: data.PdfTitle.split(' ').join(','),
        author: 'Bankei',
        creator: 'Bankei',
        producer: 'Bankei',
        creationDate: new Date()
      },
      content: table,
      styles: style
    };
    if(landscape){
      documentDefinition = {
        header: function(currentPage, pageCount, pageSize) {
          if (currentPage == 1) {
            return [
              {
                image:"data:image/png;base64,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",
                fit:[100,50],
                margin:[0,20],
                alignment:"center"
              }
            ]
          }
        },
        footer: function(currentPage, pageCount) { 
          return { 
            text: 'Página ' + currentPage.toString() + ' de ' + pageCount,
            style: 'footerPage'
          }; 
        },
        info: {
          title: data.PdfTitle,
          subject: data.PdfTitle,
          keywords: data.PdfTitle.split(' ').join(','),
          author: 'Bankei',
          creator: 'Bankei',
          producer: 'Bankei',
          creationDate: new Date()
        },
        pageOrientation: 'landscape',
        content: table,
        styles: style
      };
    }

    return pdfMake.createPdf(documentDefinition);
  }
    
  generatePdfRps(item){
    
    let date: any = new Date(item.emissao);
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    let contento = []

    let tam = environment.TOTAL_CARACTERE_CNPJ - item.documento.length;
    let str = item.documento.toString();
    for (let i = 0; i < tam; i++) {
        str = '0' + str;
    }
    item.documento = str;
    
    tam = 9 - item.id.toString().length;
    str = item.id.toString();
    for (let i = 0; i < tam; i++) {
        str = '0' + str;
    }
    item.id = str;

    let tellMask;
    
    console.log("CNPJ: ",item.telefone.toString().length)

    if(item.telefone.toString().length == 10)
    {
      tellMask = '(##) ####-####'
    } else if (item.telefone.toString().length == 11) {
      tellMask = '(##) #####-####'
    } else {
      item.telefone = '' 
      tellMask = ''      
    }

    
    contento.push(
      {
        columns: [
          {
            image: 'data:image/png;base64,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',
            fit: [125, 50],
            margin: [0,7] 
          },
          {
            text: [
              'BANKEI BENEFLEX ENEFICIOS E SIMILARES S/A\n',
              'CNPJ: 34.774.978/0001-22 INSC. MUNICIP: 110710\n',
              'RUA NITEROI 400, CJ 504\n',
              'CENTRO, SÃO CAETANO DO SUL, SP\n',
              '09510-200'
            ],
            fontSize: 10,
            margin: [-60,0] 
          },
          {
            width: 'auto',
            text: [
              'RPS N°: ' + item.id + '\n',
              'Data de emissão:\n' + date[0] + '/' + date[1] + '/' + date[2]
            ],
          }  
        ] 
      },
      {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 2}],style: 'linha'},
      {
        text: 'Recibo Provisório de Serviços (RPS)',
        bold: true,
        fontSize: 18,
        alignment: 'center',
      },
      {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 2}],style: 'linha'},
      {
        text: [{text: 'Razão Social:\n', bold: true},item.razaoSocial],
        style: 'texto'
      },
      {
        columns: [
          {
            text: [{text: 'CPF/CNPJ:\n', bold: true},this.format(item.documento, '##.###-###/####-##')],
            style: 'texto'
          },
          {
            text: [{text: 'Inscrição Estadual:\n', bold: true},item.inscricaoEstadual],
            style: 'texto'
          },
          {
            text: [{text: 'Inscrição Municipal:\n', bold: true},item.inscricaoMunicipal],
            style: 'texto'
          },
          {
            text: [{text: 'DDD/Telefone/FAX:\n', bold: true},this.format(item.telefone,tellMask)],
            style: 'texto'
          } 
        ]
      },
      {
        text: [{text: 'Endereço:\n', bold: true},item.endereco + ', ' + item.numero],
        style: 'texto'
      },
      {
        columns: [
          {
            text: [{text: 'Bairro:\n', bold: true},item.bairro],
            style: 'texto'
          },
          {
            text: [{text: 'Município:\n', bold: true},item.cidade],
            style: 'texto'
          },
          {
            width: 50,
            text: [{text: 'UF:\n', bold: true},item.uf],
            style: 'texto'
          },
          {
            width: 'auto',
            text: [{text: 'CEP:\n', bold: true},this.format(item.cep,'#####-###')],
            style: 'texto'
          }
        ]
      },    
      {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 2}],style: 'linha'},
      {
          text: [{text: 'Dados Complementares:\n', bold: true},'Valor Líquido ' + item.valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
        style: 'texto'
      },
      {
        text: 'Dados do(s) pedido(s)', 
        bold: true,
        style: 'texto'
      }
    );

    item.rpsItens.forEach(e => {
      contento.push({
        columns: [
          {
            text: [{text: 'Número:\n', bold: true},'1'],
            style: 'texto'
          },
          {
            text: [{text: 'Quantidade:\n', bold: true},e.quantidade],
            style: 'texto'
          },
          {
            text: [{text: 'Descrição:\n', bold: true},e.descricao],
            style: 'texto'
          },
          {
            text: [{text: 'Valor Unitário:\n', bold: true},e.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
            style: 'texto',
            alignment: 'right'
          },
          {
            text: [{text: 'Valor Total:\n', bold: true},(e.valor*e.quantidade).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
            style: 'texto',
            alignment: 'right'
          }
        ]          
      })
    });

    contento.push(
      {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 2}],style: 'linha'},
      {
        text: 'Valor do pedido: ' + item.valorTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            style: 'texto',
        alignment: 'right'
      },	
      {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 2}],style: 'linha'},
      {
        text: 'Discriminação de Serviços:',
        bold: true,
        style: 'texto'
      }
    );

    item.discriminacaoServicos.forEach(e => {
      contento.push({
        columns: [
          {
            text: [{text: 'Código:\n', bold: true},'1'],
            style: 'texto'
          },
          {
            text: [{text: 'Quantidade:\n', bold: true},e.quantidade],
            style: 'texto'
          },
          {
            text: [{text: 'Descrição:\n', bold: true},e.descricao],
            style: 'texto'
          },
          {
            text: [{text: 'Valor Unitário:\n', bold: true},e.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
            style: 'texto',
            alignment: 'right'
          },
          {
            text: [{text: 'Valor Total:\n', bold: true},(e.valor*e.quantidade).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
            style: 'texto',
            alignment: 'right'
          }
        ]
      })
    }); 
    
    contento.push({
      columns: [
        {
          text: [{text: 'Base de Cálculo:\n', bold: true},item.baseCalculo.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
          style: 'texto'
        },
        {
          text: [{text: 'ISS:\n', bold: true},item.iss.toLocaleString(undefined, { minimumFractionDigits: 2 }) + '%'],
          style: 'texto'
        },
        {
          text: [{text: 'Valor IR:\n', bold: true},item.valorIR.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
          style: 'texto'
        },
        {
          text: [{text: 'Valor Total:\n', bold: true},(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
          style: 'texto',
          alignment: 'right'
        }
      ]
    },	
    {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 2}],style: 'linha'},
    {
      text: 'Outras Informações:',
      bold: true,
          style: 'texto'
    },
    {
      text: 'NÃO TEM VALOR COMO DOCUMENTO FISCAL\nEste Recibo Provisorio de Serviços (RPS) deverá ser convertido em Nota Fiscal Eletronica - NFS-e em até 10 (dez) dias, contados da data de sua emissão\n\nA Nota Fiscal Eletrônica será emitida de arcodo com o Decreto 9.867 de 27/03/2009 da Prefeitura de de São Caetano do Sul',
      alignment: 'justify',
      fontSize: 12,
      margin: [15,0]
    },
    {canvas: [ { type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 2}],style: 'linha'},
    {
      text: 'Dados da Nota Fiscal Eletrônica correspondente este Demonstrativo (RPS)',
      bold: true,
          style: 'texto'
    },
    {
      text: [
        {text: 'Nota Fiscal Eletrônica N: ', bold: true}, item.notaFiscal!=0? item.notaFiscal : '',
        {text: '\nCódigo de Autenticidade: ', bold: true}, item.codigoAutenticidade??''
      ],
      style: 'texto'
    },
    {
      text: 'Para consultar a NFe acesse o site da prefeitura de São Caetano do Sul ',
      style: 'texto'
    });
    
    const documentDefinition = {
      info: {
        title: 'recibo-provisorio_servico-' + item.id,
        subject: 'recibo-provisorio_servico-' + item.id,
        keywords: 'recibo,provisorio,servico',
        author: 'Bankei',
        creator: 'Bankei',
        producer: 'Bankei',
        creationDate: new Date()
      },
      content: contento,
      styles: {
        linha: {
          margin: [0, 5]
        },
        header: {
          bold: true
        },
        texto: {
          margin: [0,5]
        }
      }
    }
    return pdfMake.createPdf(documentDefinition);
    //*/
  }

  generatePdfPurchases(purchase, purchaseItens, orderItems, orderItemsError) {

    const content = []

    // Detalhes da recarga --------------------------------------------------------------------------

    content.push(
      {
        text: 'Dados da recarga: ' + purchase.id, style: 'title'
      },
      {
        stack: [
          { text: 'Produtos:', style: 'titlDetails' },
          { text: purchase.products.join(", "), style: 'itemDetails' },
        ]
      },
      {
        columns: [
          {
            stack: [
              { text: 'Quantidade de produtos:', style: 'titlDetails' },
              { text: purchase.quantity, style: 'itemDetails' },

            ]
          },
          {
            stack: [
              { text: 'Meio de pagamento: ', style: 'titlDetails' },
              { text: purchase.paymentMethodDescription, style: 'itemDetails' },
            ]
          },
          {
            stack: [
              { text: 'Status:', style: 'titlDetails' },
              { text: purchase.purchaseStateDescription, style: 'itemDetails' },
            ]
          },
          {
            stack: [
              { text: 'Data e hora da recarga: ', style: 'titlDetails' },
              { text: purchase.purchaseDate, style: 'itemDetails' },
            ]
          },
          purchase.releaseDate ?
            {
              stack: [
                { text: 'Data e hora de provisionamento:', style: 'titlDetails' },
                { text: purchase.releaseDate, style: 'itemDetails' },

              ]
            }
            :
            {}
        ]
      },
      {
        columns: [
          {
            stack: [
              { text: 'Valor total da recarga: ', style: 'titlDetails' },
              { text: purchase.purchaseValue, style: 'itemDetails' },
            ]
          },
          {
            stack: [
              { text: 'Valor a ser pago:', style: 'titlDetails' },
              { text: purchase.purchaseToPayValue, style: 'itemDetails' },

            ]
          },
          {
            stack: [
              { text: 'Valor da taxa: ', style: 'titlDetails' },
              { text: purchase.purchaseFee, style: 'itemDetails' },

            ]
          },
          {
            stack: [
              { text: 'Valor a ser disponibilizado:', style: 'titlDetails' },
              { text: purchase.purchaseValueToDeliver, style: 'itemDetails' }

            ]
          }
          , {}
        ]
      },
      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 762, y2: 0, lineWidth: 2 }], style: 'linha' },
    );

    // Tabela de itens da recarga --------------------------------------------------------------------------

    const bodyPI = [];
    bodyPI.push(
      [
        { text: 'Produto', style: 'tableHeader' },
        { text: 'Valor', style: 'tableHeader', colSpan: 2 },
        { text: '', style: 'tableHeader' },
        { text: 'Comentário', style: 'tableHeader' },
        { text: 'Situação', style: 'tableHeader' }
      ]
    );

    purchaseItens.forEach((r) => {
      const rows = [];
      r.forEach((i) => {
        i = i ? i + '' : '-'
        if (i.includes('R$ ')) {
          rows.push({
            text: 'R$',
            style: 'tableBody'
          });
          rows.push({
            text: i.replace('R$ ', ''),
            style: 'tableBody',
            alignment: 'right'
          });
        }
        else {
          rows.push({
            text: i.length > 25 ? this.breakText(i) : i,
            style: 'tableBody'
          });
        }

      });
      bodyPI.push(rows);
    });

    content.push(
      {
        table: {
          dontBreakRows: true,
          headerRows: 1,
          widths: ['auto', 'auto', 'auto', 'auto', 'auto'],
          body: bodyPI
        },
        layout: {
          hLineWidth: function (i, node) { return 1; },
          vLineWidth: function (i, node) {
            return (i == 2) ? 0 : 1;
          },

          paddingLeft: function (i, node) { return 5; },
          paddingRight: function (i, node) { return 5; },

          hLineColor: function (i, node) { return '#dedede'; },
          vLineColor: function (i, node) { return '#dedede'; },

          paddingTop: function (i, node) { return 2; },
          paddingBottom: function (i, node) { return 2; },

          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex % 2 === 0) ? null : '#f2f2f2';
          }
        }
      },
      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 762, y2: 0, lineWidth: 2 }], style: 'linha' },
    );

    // Tabela de itens do pedido --------------------------------------------------------------------------s

   /* const headersOI = [];
    headersOI.push(
      {
        text: 'Nome',
        style: 'tableHeader'
      },
      {
        text: 'CPF',
        style: 'tableHeader'
      },
      {
        text: 'Matrícula',
        style: 'tableHeader'
      },
      {
        text: '',
        style: 'tableHeader'
      }
    );
    const widths = ['auto', 'auto', 'auto', 'auto'];
    const currency = [false, false, false, false];

    const bodyOI = [];
    bodyOI.push(headersOI);

    orderItems.rows.forEach((row, index) => {
      const rows = [];
      row.forEach((cell) => {
        cell = cell ? cell + '' : '-'
        rows.push({
          text: cell.length > 25 ? this.breakText(cell) : cell,
          style: 'tableBody'
        });
      });

      const widths2 = ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
      const bodyOI2 = [];

      /orderItems.values[index].forEach(element => {
        var i_chunk, j_chunk, temporary, chunk = 8;

        for (i_chunk = 0, j_chunk = orderItems.headers.length; i_chunk < j_chunk; i_chunk += chunk) {
          temporary = orderItems.headers.slice(i_chunk, i_chunk + chunk);
          rows2.push({
            text: element
          });
          if (i_chunk == 0) { widths2.push('auto'); }
        }
        bodyOI2.push(rows2)
      });*

      var i_chunk, j_chunk, temporary, chunk = 6;

      for (i_chunk = 0, j_chunk = orderItems.values[index].length; i_chunk < j_chunk; i_chunk += chunk) {
        temporary = orderItems.values[index].slice(i_chunk, i_chunk + chunk);
        console.log(temporary)
        const rows2 = [];
        for (var tmpIndex = 0; tmpIndex < chunk; tmpIndex++) {
          if (tmpIndex < temporary.length) {
            if (temporary[tmpIndex].includes('R$ ')) {
              rows2.push({
                text: 'R$',
                style: 'tableBody'
              });
              rows2.push({
                text: temporary[tmpIndex].replace('R$ ', ''),
                style: 'tableBody',
                //alignment: 'right'
              });
            }
            else {
              rows2.push({
                text: temporary[tmpIndex],
                style: 'tableBody'
              });
            }
          } else if (tmpIndex == temporary.length) {
            rows2.push({
              text: "",
              colSpan: (chunk - 9)
            });
          } else {
            rows2.push({
              text: ""
            });
            if ((tmpIndex+1) % 2 === 0){
              rows2.push({
                text: ""
              });              
            }
          }
          //if (i_chunk == 0) { widths2.push('auto'); }
        }
        bodyOI2.push(rows2)
      }


      rows.push(
        {
          table: {
            keepWithHeaderRows: 1,
            dontBreakRows: true,
            headerRows: 1,
            widths: widths2,
            body: bodyOI2
          },
          layout: {
            hLineWidth: function (i, node) { return 1; },
            vLineWidth: function (i, node) {
              return ((i-2) % 3 === 0) ? 0 : 1;
            },

            paddingLeft: function (i, node) { return 5; },
            paddingRight: function (i, node) { return 5; },

            hLineColor: function (i, node) { return '#dedede'; },
            vLineColor: function (i, node) { return '#dedede'; },

            paddingTop: function (i, node) { return 2; },
            paddingBottom: function (i, node) { return 2; },

            fillColor: function (rowIndex, node, columnIndex) {
              return (rowIndex % 2 === 0) ? null : '#f2f2f2';
            }
          }
        }
      )

      bodyOI.push(rows);
    });

    content.push(
      {
        table: {
          keepWithHeaderRows: 1,
          dontBreakRows: true,
          headerRows: 1,
          widths: widths,
          body: bodyOI
        },
        margin: [0, 5],
        layout: {
          hLineWidth: function (i, node) { return 1; },
          vLineWidth: function (i, node) {
            return (currency[i - 1]) ? 0 : 1;
          },

          paddingLeft: function (i, node) { return 5; },
          paddingRight: function (i, node) { return 5; },

          hLineColor: function (i, node) { return '#dedede'; },
          vLineColor: function (i, node) { return '#dedede'; },

          paddingTop: function (i, node) { return 2; },
          paddingBottom: function (i, node) { return 2; },

          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex % 2 === 0) ? null : '#f2f2f2';
          }
        }
      }
    );*/


    // Tabela de itens do pedido --------------------------------------------------------------------------s

    var i_chunk, j_chunk, temporary, chunk = 7;

    for (i_chunk = 0, j_chunk = orderItems.headers.length; i_chunk < j_chunk; i_chunk += chunk) {
      temporary = orderItems.headers.slice(i_chunk, i_chunk + chunk);

      const headersOI = [];
      headersOI.push(
        {
          text: 'Nome',
          style: 'tableHeader'
        },
        {
          text: 'CPF',
          style: 'tableHeader'
        },
        {
          text: 'Matrícula',
          style: 'tableHeader'
        }
      );
      const widths = ['auto', 'auto', 'auto'];
      const currency = [false, false, false];

      temporary.forEach((h, i) => {
        //console.log('Header: ',h)
        currency.push(true)
        headersOI.push({
          text: h,
          style: 'tableHeader',
          colSpan: 2
        });
        widths.push('auto');
        currency.push(false)
        headersOI.push({
          text: '',
          style: 'tableHeader',
        });
        widths.push('auto');
      });

      const bodyOI = [];
      bodyOI.push(headersOI);

      orderItems.rows.forEach((row) => {
        const rows = [];
        row.forEach((cell, index) => {
          if (index <= 2 || (index >= (i_chunk+3) && index < (i_chunk+chunk+3))) {
            cell = cell ? cell + '' : '-'
            if (cell.includes('R$ ')) {
              rows.push({
                text: 'R$',
                style: 'tableBody'
              });
              rows.push({
                text: cell.replace('R$ ', ''),
                style: 'tableBody',
                alignment: 'right'
              });
            }
            else {
              rows.push({
                text: cell.length > 25 ? this.breakText(cell) : cell,
                style: 'tableBody'
              });
            }
          }
        });
        bodyOI.push(rows);
      });

      content.push(
        {
          table: {
            keepWithHeaderRows: 1,
            dontBreakRows: true,
            headerRows: 1,
            widths: widths,
            body: bodyOI
          },
          margin: [0,5], 
          layout: {
            hLineWidth: function (i, node) { return 1; },
            vLineWidth: function (i, node) {
              return (currency[i - 1]) ? 0 : 1;
            },

            paddingLeft: function (i, node) { return 5; },
            paddingRight: function (i, node) { return 5; },

            hLineColor: function (i, node) { return '#dedede'; },
            vLineColor: function (i, node) { return '#dedede'; },

            paddingTop: function (i, node) { return 2; },
            paddingBottom: function (i, node) { return 2; },

            fillColor: function (rowIndex, node, columnIndex) {
              return (rowIndex % 2 === 0) ? null : '#f2f2f2';
            }
          }
        }
      );
    }

    // tabela do itens do pedido que falharam

    if (orderItemsError?.length > 0) {
      const bodyOIE = [];
      bodyOIE.push(
        [
          { text: 'Nome', style: 'tableHeader' },
          { text: 'CPF', style: 'tableHeader' },
          { text: 'Matrícula', style: 'tableHeader' },
          { text: 'Produto', style: 'tableHeader' },
          { text: 'Valor', style: 'tableHeader', colSpan: 2 },
          { text: '', style: 'tableHeader' },
          { text: 'Situação', style: 'tableHeader' }
        ]
      );

      
      orderItemsError = orderItemsError.sort((a, b) => a[0].localeCompare(b[0]) || a[3].localeCompare(b[3]));

      orderItemsError.forEach((r) => {
        const rows = [];
        r.forEach((i) => {
          i = i ? i + '' : '-'
          if (i.includes('R$ ')) {
            rows.push({
              text: 'R$',
              style: 'tableBody'
            });
            rows.push({
              text: i.replace('R$ ', ''),
              style: 'tableBody',
              alignment: 'right'
            });
          }
          else {
            rows.push({
              text: i.length > 25 ? this.breakText(i) : i,
              style: 'tableBody'
            });
          }

        });
        bodyOIE.push(rows);
      });

      content.push(
        { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 762, y2: 0, lineWidth: 2 }], style: 'linha' },
        {
          table: {
            dontBreakRows: true,
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: bodyOIE
          },
          layout: {
            hLineWidth: function (i, node) { return 1; },
            vLineWidth: function (i, node) {
              return (i == 5) ? 0 : 1;
            },

            paddingLeft: function (i, node) { return 5; },
            paddingRight: function (i, node) { return 5; },

            hLineColor: function (i, node) { return '#dedede'; },
            vLineColor: function (i, node) { return '#dedede'; },

            paddingTop: function (i, node) { return 2; },
            paddingBottom: function (i, node) { return 2; },

            fillColor: function (rowIndex, node, columnIndex) {
              return (rowIndex % 2 === 0) ? null : '#f2f2f2';
            }
          }
        }
      );
    }
    const documentDefinition = {
      header: function (currentPage, pageCount, pageSize) {
        if (currentPage == 1) {
          return [
            {
              image: "data:image/png;base64,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",
              fit: [100, 50],
              margin: [0, 20],
              alignment: "center"
            }
          ]
        }
      },
      footer: function (currentPage, pageCount) {
        return {
          text: 'Página ' + currentPage.toString() + ' de ' + pageCount,
          style: 'footerPage'
        };
      },
      info: {
        /*title: 'recibo-provisorio_servico-' + item.id,
        subject: 'recibo-provisorio_servico-' + item.id,
        keywords: 'recibo,provisorio,servico',*/
        author: 'Bankei',
        creator: 'Bankei',
        producer: 'Bankei',
        creationDate: new Date()
      },
      pageOrientation: 'landscape',
      content: content,
      styles: {
        titlDetails: {
          bold: true,
          alignment: 'justify',
          margin: [0, 10, 0, 0]
        },
        itemDetails: {
          margin: [2, 0, 0, 0]
        },
        linha: {
          margin: [0, 10]
        },
        tableHeader: {
          bold: true
        },
        tableBody: {
          unbreakable: true,
        },
        footerPage: {
          unbreakable: true,
          fontSize: 9,
          margin: [20, 10],
          alignment: 'right'
        },
        title: {
          fontSize: 14,
          bold: true,
          margin: [0, 20, 0, 0]
        },
      },
      defaultStyle: {
        fontSize: 9
      }
    }

    // console.log(JSON.stringify(documentDefinition))
    return pdfMake.createPdf(documentDefinition);
  }

  format(value, pattern) {
    var i = 0,
        v = value.toString();
    return pattern.replace(/#/g, _ => v[i++]);
  }

  formatDate(str){
    return str.split('/').reverse().join('/');
  }

  breakText (str){
    let strArray = str.split(" ");
    let txt = '';
    let aux = '';
  
    for (let i=0;i<strArray.length;i++) {
      let aux2 = txt.split('\n');
      aux = aux2[aux2.length-1]
      aux += (aux==''?'':' ') + strArray[i];
      if (aux.length > 25 && str.length > 40) {
        txt += '\n' + strArray[i];
      } else {
        txt += (aux==''?'':' ') + strArray[i];
      }
    }
    return txt;
  }
}


export class PdfData {
  PdfTitle: string;
  PdfHeaders: Array<string>;
  PdfRows: Array<Array<string>>;
}
